<script setup>
const props = defineProps({
  headline: {
    type: String,
    required: false,
  },
  items: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div>
    <h2 v-text="props.headline" class="section-headline mb-3 lg:mb-6"></h2>
    <div class="flex gap-6 flex-wrap">
      <a
        v-for="item in items"
        :key="item.id"
        v-text="item.name"
        class="bg-primary/10 font-medium text-16 lg:text-20 px-6 py-4"
        :href="item.link"
      >
      </a>
    </div>
  </div>
</template>
